const ExternalIcon = ({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element => (
  <svg
    width={12}
    height={11}
    viewBox='0 0 12 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1 1.154h9.063v9.062M9.75 1.466L1.625 9.591'
      stroke='currentColor'
      strokeWidth={2}
    />
  </svg>
)

export default ExternalIcon
